export const UPDATE_VARIABLE_STATE = "UPDATE_VARIABLE_STATE"
export const VARIABLE_DELETED = "VARIABLE_DELETED"
export const VARIABLE_CREATED = "VARIABLE_CREATE"
export const VARIABLE_UPDATED = "VARIABLE_UPDATED"
